import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose } from "../../components/v2/icons";
import { Input, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper } from "./layout.c";
import { UI } from '../../../core/ui';
import { Select } from '@lib/components/src';
import { syncDashboardLocalize } from '../../../core/localize-dashboard';


interface Props extends WithTranslation {}
interface State {
    toggle: boolean;
    version?: string;
    menu_api: 'standard' | 'original';
    translation_api_key: string;
}

@inject("store") @observer
class QuickSettingsClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
        this.state = {
            toggle: false,
            version: 'v1',
            menu_api: 'original',
            translation_api_key: ''
        };
	}

    componentDidMount(): void {
        const { organisation } = this.injected.store
        this.setState({
            toggle: (organisation!.dashboard == 'v2'),
            version: organisation!.dashboard,
            menu_api: organisation!.menu || 'original',
            translation_api_key: organisation!.translation_api_key || ''
        })
    }

    render() {
        const { store, t} = this.injected;
        const { organisation } = store;
        if(!organisation) return
        return (
        <QuickSettingsContainer className={store.view.quicksettings_active ? 'active': ''}>
            <QuickSettingsHeaderWrapper>
                <HeaderTitleWrapper style={{justifyContent: 'start'}}>
                    <IconSettings />
                    <div>Quick Settings</div>
                </HeaderTitleWrapper>
                <MenuItem onClick={() => store.updateView({quicksettings_active: false})}><IconClose /></MenuItem>
            </QuickSettingsHeaderWrapper>
            <QuickSettingsBodyWrapper>
                <QuickSettingsItemsContainer style={{flexDirection: 'column', alignItems: 'start'}}>
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper>
                            <span>Use Modern Layout</span>
                            <Switch
                            id="switch-layout"
                            checked={organisation.dashboard ? organisation.dashboard == 'v2': false}
                            onChange={(e) => {
                                store.updateOrganisation({
                                    dashboard: e.target.checked ?  'v2' : 'v1'
                                })

                                this.setState({
                                    version: e.target.checked ? 'v2' : 'v1'
                                })
    
                             
                            }} />
                        </QuickSettingsItemWrapper>
                        <p>Ordering dashboard is currently using the classic layout.</p>
                    </QuickSettingsItemsWrapper>

                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Menu API</span>

                            <Select
                                value={this.state.menu_api}
                                options={[
                                    {label: '1.0', value: 'original'},
                                    {label: '2.0', value: 'standard'},
                                ]}
                                onChange={(e) => {
                                    this.setState({
                                        menu_api: e.target.value as 'standard' | 'original'
                                    })
                                }}/>
                        </QuickSettingsItemWrapper>
                        <p>Ordering dashboard is currently using the {this.state.menu_api} menu schema.</p>
                    </QuickSettingsItemsWrapper>
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Translation API Key (optional)</span>

                            <Input
                                type="password"
                                autoComplete="off"
                                spellCheck={false}
                                value={this.state.translation_api_key}
                                onChange={(e) => {
                                    this.setState({
                                        translation_api_key: e.target.value
                                    })
                                }}
                            />
                        </QuickSettingsItemWrapper>
                        <p>
                            {t('localizeKeyHelp', {
                                defaultValue: 'Key used to translate the admin dashboard UI. Only set this if you have your own translator key.'
                            })}
                        </p>
                    </QuickSettingsItemsWrapper>
                </QuickSettingsItemsContainer>
            </QuickSettingsBodyWrapper>
            <QuickSettingsFooterWrapper>
                <QuickSettingsButton
                    onClick={() => {
                        store.updateView({quicksettings_active: false})
                        const translationKey = this.state.translation_api_key.trim();
                        store.updateOrganisation({
                            dashboard: this.state.version,
                            menu: this.state.menu_api,
                            translation_api_key: translationKey.length > 0 ? translationKey : ''
                        })
                        store.api.organisation_update({
                            _id: organisation._id,
                            update: {
                                $set: {
                                    dashboard: this.state.version,
                                    menu: this.state.menu_api,
                                    translation_api_key: translationKey
                                }
                            }
                        }).then(() => {
                            UI.notification.success("Settings updated");
                            syncDashboardLocalize(store.reseller, store.organisation);
                        })
                    }}>
                    Save Settings
                </QuickSettingsButton>
            </QuickSettingsFooterWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const QuickSettings = withTranslation()(QuickSettingsClass);
